import { useCommandBar } from "../hooks/useCommandBar";
import { useRecordNavigationClick } from "../hooks/useRecordNavigationClick";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";

export function SearchButton() {
  const { open, toggle } = useCommandBar();
  const recordClick = useRecordNavigationClick();

  return (
    <Tooltip
      content={
        <>
          Search{" "}
          <span style={{ fontSize: 10, color: "var(--text-secondary)" }}>
            ⌘K
          </span>
        </>
      }
    >
      <Button
        variant="secondary"
        size="l"
        icon="search"
        onMouseDown={() => {
          if (!open) recordClick("top_bar", "search");
          toggle();
        }}
        aria-label="Search"
      />
    </Tooltip>
  );
}
